// PB lettermark — replaces the prototype's pb-icon.png. Sits at the
// top-left of the topbar. The glow lives on the letters themselves
// (text-shadow) so the accent reads as a halo radiating out from behind
// the PB rather than as a box outline.

export function PBMark(): JSX.Element {
  return (
    <div
      aria-hidden
      className="relative grid h-8 w-8 shrink-0 place-items-center rounded-md font-display text-base font-bold tracking-tighter leading-none text-text"
      style={{
        textShadow:
          '0 0 6px color-mix(in srgb, var(--pb-accent) 70%, transparent), 0 0 14px color-mix(in srgb, var(--pb-accent) 45%, transparent)',
      }}
    >
      PB
    </div>
  );
}
